import Home from "../components/pages/Home"
import { HOME } from "./paths";

export const routes = [
    {
        path: HOME,
        element: <Home />
    }
];